import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
// import {
//   store
// } from '@/store/store';
import axios from 'axios';
import Nprogress from 'nprogress'
import 'nprogress/nprogress.css';
import 'vue-swatches/dist/vue-swatches.css'
import 'nprogress/nprogress.js';
import Notifications from 'vue-notification'
import * as VueGoogleMaps from 'vue2-google-maps'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import VueGeolocation from 'vue-browser-geolocation';
import helpers from "@/helpers/helpers";
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
//import storeState from '@/store/modules/layout/index'
import ProgressBar from 'vuejs-progress-bar';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import axiosapi from '@/api/index'
import { createPinia } from 'pinia'
Vue.use(createPinia())

localStorage.setItem('socketConnected', "no");
const treeSelectplugin = {
  install() {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  },
};
Vue.use(ProgressBar)
Vue.use(treeSelectplugin);
Vue.use(VueGeolocation);

// Init plugin
Vue.use(Loading);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAZaKw4VI0yelXUEj2KsL97ZjpHX8bF3zU',
    v: '3.26',
  },
})
Vue.use(Notifications)
Vue.config.productionTip = false
const reqInterceptor = axios.interceptors.request.use(config => {
  console.log('Request Interceptor', config)
  return config
})
const resInterceptor = axios.interceptors.response.use(res => {
  console.log('Response Interceptor', res)
  return res
})
axios.interceptors.request.eject(reqInterceptor)
axios.interceptors.response.eject(resInterceptor)

Vue.directive('click-outside', {
  bind: function (el, binding, vNode) {

    const bubble = binding.modifiers.bubble;
    const handler = e => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;
    document.addEventListener("click", handler);
  },

  unbind: function (el, binding) {
    document.removeEventListener("click", el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
})
window.addEventListener('build', function (e) {
  let adminId = localStorage.getItem("socAdmin")
  let socEnable = localStorage.getItem("socEnable")
  let socketConnected = localStorage.getItem("socketConnected")
  if (socEnable != null && socEnable != undefined && adminId != null && adminId != undefined && socketConnected == "no" && socEnable == "true") {
    const socket = io('https://' + window.location.hostname + ":" + location.port, { transports: ['websocket'] });
    socket.on('connect', function () {
      console.log("socket connected");
      localStorage.setItem('socketConnected', "yes");
      socket.emit('room', adminId + '-header');
      Vue.use(VueSocketIOExt, socket);
    })
  } else {
    localStorage.setItem('socketConnected', "no");
  }
}, false);

window.addEventListener('storage', (event) => {
  if (localStorage.getItem("token") === "logout") {
    localStorage.removeItem('expirationDate')
    localStorage.removeItem('token')
    localStorage.removeItem('adminDetails')
    location.reload();
  }
});
const hostname = window.location.hostname;
// Set default values based on hostname
if (hostname === 'cloud.jazenetworks.com' || hostname === 'live.jazenetworks.com' || hostname === 'isp.jazenetworks.com') {
  localStorage.setItem('useGoogleAnalytics', "yes");
} else {
  localStorage.setItem('useGoogleAnalytics', "no");
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
